import { Link, FieldProps, useRecordContext, ReferenceManyCount } from 'react-admin';
import { Subjects } from '../../custom';
import { useParams } from 'react-router';

const ChaptersLinkField = (props: FieldProps<Subjects>) => {
    let { programId } = useParams();

    const record = useRecordContext<Subjects>();
    if (!record) {
        return null;
    }
    return <Link to={`/programs/${programId}/subjects/${record.id}/chapters`}>Chapters</Link>;
};

ChaptersLinkField.defaultProps = {
    label: 'Chapters',
};

export default ChaptersLinkField;
